// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type CareerHubTopicsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CareerHubTopicsQuery = {
  __typename?: 'Query';
  careerHubTopics?: {
    __typename?: 'CareerHubTopicsResponse';
    collection: Array<{
      __typename?: 'CareerHubTopic';
      title: string;
      description?: string | null;
      key: string;
      trackingKey: string;
      articles: Array<{
        __typename: 'CareerHubArticle';
        id: string;
        urn: string;
        url: string;
        title: string;
        description: string;
        actorUrn: string;
        pageUrl: string;
        pageTitle: string;
        image: {
          __typename?: 'CareerHubArticleImage';
          srcWide?: string | null;
        };
        pageLogos: {
          __typename?: 'CareerHubArticlePageLogo';
          square48?: string | null;
        };
      } | null>;
    } | null>;
  } | null;
};

export const CareerHubTopicsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'careerHubTopics' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careerHubTopics' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'CareerHubTopicCollectionFragment',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareerHubArticleFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareerHubArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'urn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'srcWide' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'actorUrn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLogos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'square48' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareerHubTopicCollectionFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareerHubTopic' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'key' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CareerHubArticleFragment' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'trackingKey' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CareerHubTopicsQuery,
  CareerHubTopicsQueryVariables
>;
